import { actions } from "./actions"
import { hooks } from "./hookactions"
export let global = { hooks, actions }
